(function () {
  'use strict';

  if (window.Shopify && Shopify.designMode) return; // no-op inside the theme editor (block-selection guard)

  var BAG_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  var COLOR_MAP = {
    black:'#000',white:'#fff',red:'#e53935',blue:'#1565c0',navy:'#0d1b4b',
    green:'#2e7d32',grey:'#888',gray:'#888',pink:'#f06292',beige:'#f5f0e8',
    brown:'#6d4c41',yellow:'#fdd835',orange:'#f4511e',purple:'#6a1b9a',
    camel:'#c19a6b',cream:'#fffdd0',khaki:'#c3b091',olive:'#558b2f',
    maroon:'#880e4f',coral:'#ff6b6b',mint:'#80cbc4',lavender:'#ce93d8',
    charcoal:'#455a64',teal:'#00897b',sand:'#c2b280',stone:'#928e85',
    ivory:'#fffff0','light grey':'#d3d3d3','dark grey':'#455a64',
    'off white':'#f8f5f0','powder pink':'#f9c5d1','baby blue':'#aed6f1',
    nude:'#e8c5a5',burgundy:'#800020',wine:'#722f37',slate:'#708090',
    taupe:'#b5a99a',lilac:'#c8a2c8',mustard:'#e1ad01',rust:'#b7410e'
  };

  function getCfg() {
    try { var el = document.getElementById('qcd-config'); return el ? JSON.parse(el.textContent) : {}; }
    catch (e) { return {}; }
  }

  function money(cents, fmt) {
    if (cents == null) return '';
    var n = (cents / 100).toFixed(2);
    var ni = String(Math.round(cents / 100));
    return (fmt || '{{amount}}')
      .replace('{{amount}}', n)
      .replace('{{amount_no_decimals}}', ni)
      .replace('{{amount_with_comma_separator}}', n.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', ni);
  }

  function esc(s) { return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }

  function thumb(src, size) {
    if (!src) return '';
    return src.split('?')[0].replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

  function buildOWV(product) {
    return (product.options || []).map(function (opt, idx) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var key = 'option' + (idx + 1), seen = [], values = [];
      product.variants.forEach(function (v) {
        if (v[key] && seen.indexOf(v[key]) === -1) { seen.push(v[key]); values.push(v[key]); }
      });
      return { name: name, values: values };
    });
  }

  if (!customElements.get('quick-cart-drawer')) {
    class QuickCartDrawer extends HTMLElement {
      connectedCallback() {
        this._cfg = getCfg();
        this._product = null;
        this._owv = [];
        this._sel = [];
        this._group = [];
        this.toggleState = false;
        this._main = this.querySelector('.quick-cart-drawer__main');
        this._panel = this.querySelector('.quick-cart-drawer__blocks');

        var closeBtn = this.querySelector('.button--close');
        var backdrop = this.querySelector('.quick-cart-drawer__backdrop');
        if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this), { passive: true });
        if (backdrop) backdrop.addEventListener('click', this.close.bind(this), { passive: true });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); }, { passive: true });

        this._bindTriggers();
        this._injectIcons();
      }

      _bindTriggers() {
        var self = this;
        var run = function () {
          document.querySelectorAll('.quick-cart-drawer__trigger:not([data-qcd])').forEach(function (btn) {
            btn.setAttribute('data-qcd', '1');
            btn.addEventListener('click', function () { self._load(btn); });
          });
        };
        run();
        new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
      }

      _injectIcons() {
        var run = function () {
          document.querySelectorAll('.quick-cart-drawer__trigger:not([data-qcd-icon])').forEach(function (btn) {
            btn.setAttribute('data-qcd-icon', '1');
            var sp = document.createElement('span');
            sp.className = 'qcd-bag-icon';
            sp.setAttribute('aria-hidden', 'true');
            sp.innerHTML = BAG_SVG;
            btn.prepend(sp);
          });
        };
        run();
        new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
      }

      // Resolve the SA Variants (Variant King Combined Listing) group for a product
      // handle from the app's own data feed: window.starapps_vkcl_data.product_groups.
      // Each grouped color is a SEPARATE Shopify product, so /products/{handle}.js only
      // ever returns one color. The sibling handles + color labels + swatch hexes live
      // in this feed (the same source the app uses to inject card swatches).
      _findGroup(handle) {
        var groups = (window.starapps_vkcl_data && window.starapps_vkcl_data.product_groups) || [];
        var found = null;
        for (var i = 0; i < groups.length; i++) {
          var ov = groups[i].option_values || [];
          var hit = ov.some(function (o) { return o.published !== false && o.handle === handle; });
          if (hit) { found = groups[i]; break; }
        }
        if (!found) return [];
        return (found.option_values || []).filter(function (o) {
          return o.published !== false && o.handle;
        }).map(function (o) {
          var sv = o.swatch_value || '';
          var style = '', needimg = false;
          if (sv.charAt(0) === '#') {
            style = 'background:' + sv;
          } else if (/\.(png|jpe?g|webp|gif|svg)/i.test(sv)) {
            style = 'background-image:url(' + sv + ');background-size:cover;background-position:center';
          } else {
            needimg = true; // no custom swatch -> lazily fall back to product image
          }
          return { handle: o.handle, url: '/products/' + o.handle, label: o.option_value || '', style: style, needimg: needimg, active: o.handle === handle };
        });
      }

      // For group swatches without a custom color/image, pull the sibling product's
      // featured image as the swatch (a few small requests, only when such a group opens).
      _fillSwatchImages(container) {
        container.querySelectorAll('.qcd-swatch[data-needimg]').forEach(function (el) {
          var h = el.getAttribute('data-h');
          if (!h) return;
          fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
            var src = p.featured_image || (p.images && p.images[0]);
            if (src) {
              el.style.backgroundImage = 'url(' + thumb(src, '100x100') + ')';
              el.style.backgroundSize = 'cover';
              el.style.backgroundPosition = 'center';
            }
          }).catch(function () {});
        });
      }

      async _load(btn) {
        var url = btn.dataset.productUrl;
        if (!url) return;
        var handle = url.split('?')[0].split('/').pop();
        this._group = this._findGroup(handle);
        btn.classList.add('is--loading');
        try {
          var r = await fetch(url + '.js');
          var p = await r.json();
          await (window.scheduler && scheduler.yield ? scheduler.yield() : new Promise(function(resolve){setTimeout(resolve,0)}));
          this._setProduct(p);
          this._draw();
          this.open();
        } catch (e) { /* silent */ }
        finally { btn.classList.remove('is--loading'); }
      }

      // Load a sibling group product into the open drawer (color switch).
      async _loadUrl(url) {
        if (!url) return;
        try {
          var r = await fetch(url + '.js');
          var p = await r.json();
          await (window.scheduler && scheduler.yield ? scheduler.yield() : new Promise(function(resolve){setTimeout(resolve,0)}));
          this._setProduct(p);
          var base = url.split('?')[0];
          this._group.forEach(function (g) { g.active = g.url === base; });
          this._draw();
        } catch (e) { /* silent */ }
      }

      _setProduct(p) {
        this._product = p;
        this._owv = buildOWV(p);
        this._sel = this._owv.map(function (_, i) { return p.variants[0] ? (p.variants[0]['option' + (i + 1)] || '') : ''; });
      }

      _activeVariant() {
        var o = this._sel, p = this._product;
        return p.variants.find(function (v) {
          return v.option1 === o[0] &&
            (p.options.length < 2 || v.option2 === o[1]) &&
            (p.options.length < 3 || v.option3 === o[2]);
        }) || p.variants[0];
      }

      _draw() {
        var self = this, p = this._product, v = this._activeVariant(), c = this._cfg;
        var imgSrc = thumb(v.featured_image ? v.featured_image.src : p.featured_image, '160x160');
        var pr = money(v.price != null ? v.price : p.price, c.moneyFormat);
        var cp = v.compare_at_price > v.price ? money(v.compare_at_price, c.moneyFormat) : null;
        var avail = !!v.available;
        // #1 OOS consistency: never show a dead grey "Sold out" button. When the selected
        // variant is unavailable the CTA becomes a clickable NOTIFY ME that routes to the PDP
        // (#notify), where mavin-notify auto-opens the Omnisend back-in-stock form. Same black
        // button footprint, just a different label + action.
        var addLbl = avail ? (c.addToCart || 'Add to cart') : (c.notify || 'Notify me');

        this._main.innerHTML =
          '<div class="qcd-row">' +
            '<div class="qcd-thumb">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + esc(p.title) + '" width="80" height="80">' : '') + '</div>' +
            '<div class="qcd-meta">' +
              '<p class="qcd-title">' + esc(p.title) + '</p>' +
              '<p class="qcd-price">' + (cp ? '<s>' + cp + '</s> ' : '') + pr + '</p>' +
            '</div>' +
          '</div>' +
          '<div class="qcd-opts"></div>' +
          '<div class="qcd-actions">' +
            '<button type="button" class="qcd-add" data-vid="' + (v.id || '') + '">' + addLbl + '</button>' +
            '<a href="' + esc(p.url) + '" class="qcd-view">' + (c.viewProduct || 'View full product') + '</a>' +
          '</div>';

        this._renderOpts();
        var addBtn = this._main.querySelector('.qcd-add');
        if (addBtn) addBtn.addEventListener('click', function () { self._addToCart(); });
      }

      _renderOpts() {
        var self = this, p = this._product;
        var container = this._main.querySelector('.qcd-opts');
        if (!container) return;

        var hasGroup = self._group && self._group.length > 1;
        var rows = [];

        // Top color row sourced from the grouped sibling products (SA Variants).
        if (hasGroup) {
          var cur = self._group.filter(function (g) { return g.active; })[0];
          // Robust current-color NAME: prefer the active group member's label, else fall back to the
          // loaded product's own color option value. (The active flag can miss when the card handle and
          // the app-feed handle differ slightly -> that showed an empty "COLOR:" with no name.)
          var prodColor = '';
          self._owv.forEach(function (o, oi) { if (/color|colour/i.test(o.name)) { prodColor = self._sel[oi] || (o.values && o.values[0]) || ''; } });
          var curColor = (cur && cur.label) || prodColor;
          var swatches = self._group.map(function (g) {
            return '<button type="button" class="qcd-swatch' + (g.active ? ' sel' : '') + '" data-url="' + esc(g.url) + '" data-label="' + esc(g.label) + '"' + (g.needimg ? ' data-needimg="1" data-h="' + esc(g.handle) + '"' : '') + ' title="' + esc(g.label) + '" style="' + g.style + '"></button>';
          }).join('');
          rows.push('<div class="qcd-opt"><p class="qcd-opt-lbl">Color: <strong class="qcd-color-name">' + esc(curColor) + '</strong></p><div class="qcd-opt-vals">' + swatches + '</div></div>');
        }

        self._owv.forEach(function (opt, idx) {
          var isColor = /color|colour/i.test(opt.name);
          // When the group row is shown, skip the loaded product's redundant single-value color option.
          if (hasGroup && isColor && opt.values.length <= 1) return;

          var sel = self._sel[idx];
          var btns = opt.values.map(function (val) {
            var avail = p.variants.some(function (v) { return v['option' + (idx + 1)] === val && v.available; });
            var isSel = val === sel;
            if (isColor) {
              var style = self._swatchStyle(val, p.variants);
              return '<button type="button" class="qcd-swatch' + (isSel ? ' sel' : '') + (avail ? '' : ' oos') + '" data-i="' + idx + '" data-v="' + esc(val) + '" title="' + esc(val) + '" style="' + style + '"></button>';
            }
            return '<button type="button" class="qcd-pill' + (isSel ? ' sel' : '') + (avail ? '' : ' oos') + '" data-i="' + idx + '" data-v="' + esc(val) + '">' + esc(val) + '</button>';
          }).join('');
          // In-stock (green) / Sold-out (red) word for the SELECTED size, matching the PDP. Updates on
          // every size tap (this re-renders) and shows on open for the pre-selected size.
          var statusHtml = '';
          if (!isColor && sel) {
            var selAvail = p.variants.some(function (v) { return v['option' + (idx + 1)] === sel && v.available; });
            statusHtml = ' <span class="qcd-size-status qcd-size-status--' + (selAvail ? 'in' : 'out') + '">' + (selAvail ? 'In stock' : 'Sold out') + '</span>';
          }
          rows.push('<div class="qcd-opt"><p class="qcd-opt-lbl">' + esc(opt.name) + ': <strong>' + esc(sel) + '</strong>' + statusHtml + '</p><div class="qcd-opt-vals">' + btns + '</div></div>');
        });

        container.innerHTML = rows.join('');
        self._fillSwatchImages(container);

        container.querySelectorAll('[data-url]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            // Instant feedback (like the PDP): update the color NAME text + selected ring immediately,
            // then load the sibling product (image/price/sizes) in the background.
            // Only overwrite the name when the swatch carries a real (non-empty) label.
            // The SA-Variants feed leaves option_value empty for most color groups, so a
            // blank label would flash the name empty; leave the previous name until the
            // reload's _renderOpts() recomputes the correct color from the loaded product.
            var nameEl = container.querySelector('.qcd-color-name');
            var lbl = (btn.getAttribute('data-label') || '').trim();
            if (nameEl && lbl) { nameEl.textContent = lbl; }
            container.querySelectorAll('.qcd-swatch[data-url]').forEach(function (s) { s.classList.remove('sel'); });
            btn.classList.add('sel');
            self._loadUrl(btn.dataset.url);
          });
        });
        container.querySelectorAll('[data-i]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self._sel[+btn.dataset.i] = btn.dataset.v;
            self._refresh();
          });
        });
      }

      _refresh() {
        var v = this._activeVariant(), c = this._cfg, p = this._product;
        var imgSrc = thumb(v.featured_image ? v.featured_image.src : p.featured_image, '160x160');
        if (imgSrc) { var th = this._main.querySelector('.qcd-thumb img'); if (th) th.src = imgSrc; }

        var pr = money(v.price != null ? v.price : p.price, c.moneyFormat);
        var cp = v.compare_at_price > v.price ? money(v.compare_at_price, c.moneyFormat) : null;
        var pel = this._main.querySelector('.qcd-price');
        if (pel) pel.innerHTML = (cp ? '<s>' + cp + '</s> ' : '') + pr;

        var addBtn = this._main.querySelector('.qcd-add');
        if (addBtn) {
          addBtn.disabled = false; // OOS is now a clickable NOTIFY ME, never a disabled button
          addBtn.dataset.vid = v.id;
          addBtn.textContent = v.available ? (c.addToCart || 'Add to cart') : (c.notify || 'Notify me');
        }
        this._renderOpts();
      }

      _swatchStyle(name, variants) {
        var match = variants.find(function (v) {
          return v.option1 === name || v.option2 === name || v.option3 === name;
        });
        if (match && match.featured_image && match.featured_image.src) {
          return 'background-image:url(' + thumb(match.featured_image.src, '100x100') + ');background-size:cover;background-position:center';
        }
        var key = name.toLowerCase();
        var hex = COLOR_MAP[key] || COLOR_MAP[key.replace(/ /g, '')] || '#ccc';
        return 'background:' + hex;
      }

      _goNotify(v) {
        // Route to the PDP's back-in-stock flow (Omnisend's widget is PDP-scoped). Signal intent
        // via sessionStorage (survives same-tab nav; immune to URL hash/query stripping by the
        // preview redirect or canonical-URL cleanup); keep #notify as a harmless backup.
        var p = this._product;
        try { sessionStorage.setItem('mavin_notify_open', '1'); } catch (e) {}
        var url = (p && p.url ? p.url : location.pathname) + (v && v.id ? '?variant=' + v.id : '') + '#notify';
        window.location.href = url;
      }

      async _addToCart() {
        var v = this._activeVariant();
        if (!v || !v.available) { this._goNotify(v); return; }
        var btn = this._main.querySelector('.qcd-add');
        var c = this._cfg;
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          });
          var cartRes = await fetch('/cart.js');
          var cart = await cartRes.json();
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
          var cartNotif = document.querySelector('cart-notification');
          if (cartNotif && typeof cartNotif.renderContents === 'function') cartNotif.renderContents([]);
          this.close();
        } catch (e) {
          if (btn) { btn.disabled = false; btn.textContent = c.addToCart || 'Add to cart'; }
        }
      }

      open() {
        var self = this;
        this.toggleState = true;
        this.classList.add('is--open');
        document.body.classList.add('overflow-hidden');
        if (this._panel) {
          this._panel.setAttribute('tabindex', '0');
          setTimeout(function() { if (self._panel) self._panel.focus({ preventScroll: true }); }, 50);
        }
      }

      close() {
        if (!this.toggleState) return;
        this.toggleState = false;
        this.classList.remove('is--open');
        document.body.classList.remove('overflow-hidden');
      }
    }

    customElements.define('quick-cart-drawer', QuickCartDrawer);
  }
})();
